import React, { FC } from "react";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import PageHeading from "../Common/PageHeading/PageHeading";
import { PRIVACY_POLICY } from "../pageRoutes";
import PageContent from "../Common/PageContent/PageContent";

const sectionTitleSx = {
  fontWeight: 600,
  marginTop: 3,
  marginBottom: 1.5
};

const bodySx = {
  marginBottom: 2,
  textAlign: "left"
};

export const TermsOfService: FC = () => {
  return (
    <section>
      <PageHeading titleText="Terms of Service" />
      <PageContent styles={{ background: "white", paddingTop: "2em" }}>
        <Typography
          variant="body2"
          sx={{ marginBottom: 3, fontStyle: "italic" }}
        >
          Last Updated: March 15, 2026
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          These Terms of Service (“Terms”) govern the access to and use of
          services provided by Kivunova Ltd., including the KivuIMS platform and
          related software applications and tools (collectively referred to as
          the “Services”).
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          By accessing or using the Services, you agree to be bound by these
          Terms.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          Use of Services
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          Kivunova provides digital tools designed to help businesses manage
          inventory, operations, and related workflows. Users may access and use
          the Services solely in accordance with these Terms and applicable
          laws. Users are responsible for ensuring that their use of the
          Services complies with all relevant legal and regulatory requirements.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          User Accounts
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          Certain features of the Services require the creation of a user
          account. When creating an account, users must provide accurate and
          complete information and are responsible for maintaining the
          confidentiality of their account credentials. Users are responsible
          for all activity that occurs through their account and should notify
          Kivunova promptly if unauthorized access is suspected.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          Acceptable Use
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          Users agree not to misuse the Services or attempt to access systems,
          networks, or data without authorization. Activities that interfere
          with the proper functioning of the platform, compromise system
          security, or violate applicable laws are prohibited. Kivunova reserves
          the right to suspend or terminate accounts that violate these Terms or
          misuse the Services.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          Service Availability
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          Kivunova strives to maintain reliable access to the Services; however,
          availability may occasionally be affected by maintenance, system
          updates, technical issues, or factors beyond our control. Kivunova
          does not guarantee uninterrupted access to the Services.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          Intellectual Property
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          All software, systems, technology, and content associated with the
          Services remain the property of Kivunova Ltd. or its licensors. Users
          are granted a limited, non-exclusive right to access and use the
          Services solely for their intended business purposes in accordance
          with these Terms.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          Limitation of Liability
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          To the extent permitted by applicable law, Kivunova shall not be
          liable for indirect, incidental, or consequential damages arising from
          the use of the Services or from the inability to access the Services.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          Privacy
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          Use of the Services is also subject to our{" "}
          <Link component={RouterLink} to={PRIVACY_POLICY} underline="hover">
            Privacy Policy
          </Link>
          , which describes how personal data is collected, processed, and
          protected.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          Changes to the Terms
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          Kivunova may revise these Terms periodically to reflect operational
          changes or legal requirements. Updated Terms will be published on this
          page, and continued use of the Services after updates constitutes
          acceptance of the revised Terms.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          Governing Law
        </Typography>
        <Typography variant="body2" sx={bodySx}>
          These Terms are governed by and interpreted in accordance with the
          laws of the Republic of Rwanda, unless otherwise required by
          applicable law.
        </Typography>

        <Typography variant="h6" sx={sectionTitleSx}>
          Contact
        </Typography>
        <Typography variant="body2" sx={{ ...bodySx, marginBottom: 4 }}>
          Questions regarding these Terms may be directed to Kivunova Ltd.
          through the contact information available on our website.
        </Typography>
      </PageContent>
    </section>
  );
};

export default TermsOfService;
